export default __webpack_public_path__ + "static/media/icon-house.1082b8cf.svg";